

import Italic from '@tiptap/extension-italic'
import { ItalicActionButton } from '@/tiptap/extensions/components/ActionButton'

export default Italic.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      button: ({ editor, t }) => ({
        component: ItalicActionButton,
        componentProps: {
          editor,
          t,
        },
      }),
    }
  },
})